var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-radio',_vm._b({class:{
    'el-radio__hidden-label': _vm.isHiddenLabel,
    'is-error': !!_vm.error
  },attrs:{"label":_vm.label,"disabled":_vm.disabled,"size":"medium"},on:{"change":function($event){return _vm.$emit(_vm.emitEvent, _vm.label, _vm.localModel)}},model:{value:(_vm.localModel),callback:function ($$v) {_vm.localModel=$$v},expression:"localModel"}},'el-radio',_vm.$attrs,false),[_vm._v(_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }